import omit from 'lodash-es/omit';
import keyBy from 'lodash-es/keyBy';
// 不同类型之间，不通用的东西
const typeSpecifiedKeys = [
    // 数组
    'items',
    // 对象
    'additionalFields',
    'fields',
    'groups',
    // 其他
    'default',
    'enum',
    'enumExpr',
    'example',
    'examples',
    'methods',
];
/**
 * 假设我们有一个基础数据，及其 DataSchema（称之为 `old`），对他的字段做了一些变动。
 * 此时我们可以使用 fromJsonData 方法生成一个新的 DataSchema（以下称之为 `base`）。
 *
 * 如果对基础数据做了修改，那么，对于新数据的 DataSchema……
 *
 * - 如果直接使用 `base` 作为最终的 DataSchema，会丢失我们对 `old` 做过的修改（比如添加过 title、 description 等信息）
 *
 * - 如果直接使用 `old` ，则会遇到字段不匹配的情况。
 *
 * 此时可使用这个方法，生成最终新的 DataSchema
 *
 * 注意：不支持 $ref 和 additionalFields ！仅配合 fromJsonData 或者 PatchDataSchema 使用
 */
export default function migrateDataSchema(old, base, extraKeys = []) {
    // 类型都变了，那就只能迁移通用信息了
    if (old.type !== base.type) {
        const allTypeSpecifiedKeys = [...typeSpecifiedKeys, ...extraKeys];
        return Object.assign(Object.assign({}, omit(old, allTypeSpecifiedKeys)), base);
    }
    // 否则还有救
    const ans = Object.assign(Object.assign({}, old), base);
    // 考虑递归的情况
    if (ans.type === 'array' && old.items && base.items) {
        ans.items = migrateDataSchema(old.items, base.items, extraKeys);
    }
    if (ans.type === 'object' && old.fields && base.fields) {
        // 对象的字段列表迁移
        const fieldsLUT = keyBy(old.fields, 'id');
        ans.fields = base.fields.map((baseField) => {
            const oldField = fieldsLUT[baseField.id];
            if (!oldField)
                return baseField;
            return migrateDataSchema(oldField, baseField, extraKeys);
        });
    }
    return ans;
}
